/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createMasterRuleFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, deserializeIntoMasterRule, serializeMasterRule, serializeMasterRuleUpdateRequest, type MasterRule, type MasterRuleUpdateRequest, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { type AdditionalDataHolder, type BaseRequestBuilder, type Parsable, type ParsableFactory, type ParseNode, type RequestConfiguration, type RequestInformation, type RequestsMetadata, type SerializationWriter } from '@microsoft/kiota-abstractions';

/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MasterRuleGetResponseMember1 | MasterRule}
 */
// @ts-ignore
export function createMasterRuleGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMasterRuleGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MasterRuleGetResponseMember1}
 */
// @ts-ignore
export function createMasterRuleGetResponseMember1FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMasterRuleGetResponseMember1;
}
/**
 * The deserialization information for the current model
 * @param MasterRuleGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMasterRuleGetResponse(masterRuleGetResponse: Partial<MasterRuleGetResponseMember1 | MasterRule> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoMasterRuleGetResponseMember1(masterRuleGetResponse as MasterRuleGetResponseMember1),
        ...deserializeIntoMasterRule(masterRuleGetResponse as MasterRule),
    }
}
/**
 * The deserialization information for the current model
 * @param MasterRuleGetResponseMember1 The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMasterRuleGetResponseMember1(masterRuleGetResponseMember1: Partial<MasterRuleGetResponseMember1> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
export type MasterRuleGetResponse = MasterRuleGetResponseMember1 | MasterRule;
export interface MasterRuleGetResponseMember1 extends AdditionalDataHolder, Parsable {
}
/**
 * Builds and executes requests for operations under /MasterRule
 */
export interface MasterRuleRequestBuilder extends BaseRequestBuilder<MasterRuleRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<MasterRuleGetResponseMember1 | MasterRule>}
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<MasterRuleGetResponseMember1 | MasterRule | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: MasterRuleUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: MasterRuleUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MasterRuleGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMasterRuleGetResponse(writer: SerializationWriter, masterRuleGetResponse: Partial<MasterRuleGetResponseMember1 | MasterRule> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    serializeMasterRuleGetResponseMember1(writer, masterRuleGetResponse as MasterRuleGetResponseMember1);
    serializeMasterRule(writer, masterRuleGetResponse as MasterRule);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MasterRuleGetResponseMember1 The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMasterRuleGetResponseMember1(writer: SerializationWriter, masterRuleGetResponseMember1: Partial<MasterRuleGetResponseMember1> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!masterRuleGetResponseMember1 || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(masterRuleGetResponseMember1.additionalData);
}
/**
 * Uri template for the request builder.
 */
export const MasterRuleRequestBuilderUriTemplate = "{+baseurl}/MasterRule";
/**
 * Metadata for all the requests in the request builder.
 */
export const MasterRuleRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: MasterRuleRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createMasterRuleGetResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: MasterRuleRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeMasterRuleUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
